import React from "react";
import "./GamesWeOfferStyle.scss";
import { gamesWeOfferTextContent } from "./constant/index";
import SectionHeading from "../Common_UI_Kit/SectionHeading";
import CasinoGameCard from "./CasinoGameCard";
import CustomButton from "../Common_UI_Kit/CustomButton";
import { useNavigate } from "react-router-dom";

const GamesWeOfferSection = ({ sectionHeadingText }) => {
  const { gamesWeOfferContent } = gamesWeOfferTextContent;

  const navigate = useNavigate();

  const handleButtonClick = () => {
    navigate("/fast-games-list");
  };

  const handleCardClick = () => {
    navigate(`/fast-game-play`);
  };

  return (
    <section className="games-we-offer-section">
      <div className="games-we-offer-wrap">
        <SectionHeading>{sectionHeadingText || gamesWeOfferTextContent.headingText}</SectionHeading>

        <div className="games-we-offer-box">
          <div className="games-grid-box">
            {gamesWeOfferContent.map((game, index) => (
              <CasinoGameCard
                key={index}
                gameImageSrc={game.gameImageSrc}
                gameNameText={game.gameNameText}
                onClick={() => handleCardClick(index)}
              />
            ))}
          </div>

          <div className="btn-box">
            <CustomButton buttonType="secondary" label={gamesWeOfferTextContent.btnText} onClick={handleButtonClick} />
          </div>
        </div>
      </div>
    </section>
  );
};

export default GamesWeOfferSection;
